function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 28,
  height: 28,
  stroke: "#7BCEF6",
  strokeWidth: 2
});

const SvgBox = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/box.34c31df1.svg";
export { ForwardRef as ReactComponent };